<template>
  <div class="content draggable-content">
    <router-view></router-view>
    <MsgBox class="msgBox"></MsgBox>
  </div>
</template>

<script>
import MsgBox from "@/components/simulatorMessageBox/SimulatorMessageBox";
export default {
  name: "Content",
  components: { MsgBox },
};
</script>

<style scoped>
  .content {
    grid-area: content;
    position: fixed;
    width: 100%;
    overflow: auto;
    top: 95px;
    bottom: 41px;
    background-color: #efefef;
    padding: 8px;
  }

  .msgBox{ 
    position: fixed;
    bottom: 41px;
    z-index: 3;
  }

  @media only screen and (max-width: 1160px) {
    .content{
      top: 128px;
    }
  } 
  
</style>
